<template >
  <span style="display: block; min-width: 10em; max-width: 100%;">
    <template v-if="schema.attributes.editing && !disabledForAdminOnly">
      <textarea
        class="form-input"
        v-model="value"
        :id="getFieldID(schema)"
        :class="schema.fieldClasses"
        :maxlength="schema.max ? schema.max : null"
        :minlength="schema.min"
        :placeholder="schema.placeholder"
        :readonly="schema.readonly"
        :rows="schema.rows || 3"
        :nameId="schema.inputName"
      />
      <div v-if="schema.inputType === 'text' && schema.max">
          <span
            v-if="schema.max"
              :class="{ 'text-danger': value && value.length > schema.max,
              'text-success': value === null || value.length <= schema.max }">
          Provided <strong>{{ !!value ? value.length : 0 }} out of
            {{ schema.max }}</strong> characters.
        </span>
      </div>
    </template>
    <template v-else>
      <template v-if="!displayAsCode">
        <p
          v-if="!lodash.isNull(value)"
          class="response"
          v-html="prettyValue"></p>
        <p
            v-else-if="!schema.attributes.editing"
            style="font-style: italic; color: #666">
          Not available
        </p>
      </template>
      <template v-if="displayAsCode">
        <pre
          v-if="!lodash.isNull(value)"
          class="response" v-text="value"></pre>
        <pre
            v-else-if="!schema.attributes.editing"
            style="font-style: italic; color: #666">
          Not available
        </pre>
      </template>
    </template>
    <div
      class="form-input-hint text-error"
      v-if="schema.attributes.editing && disabledForAdminOnly">
      Field is restricted to site administrators.
    </div>
  </span>
</template>

<script>
import sanitize from 'sanitize-html';

import { MixinDataToReactiveData } from 'assets/js/util';
import { abstractField } from 'components/Widgets/FormGenerator';
import { urls2html } from 'assets/js/strings';

import FieldCommon from './FieldCommon';

export default {
  name: 'field-q-text-area',
  mixins: [abstractField, FieldCommon],

  setup() {
    const afd = MixinDataToReactiveData(abstractField);
    const fcd = MixinDataToReactiveData(FieldCommon);
    return {
      ...afd,
      ...fcd,
    };
  },

  computed: {
    // prettyValue replaces value/null with value/(none).
    prettyValue() {
      const opts = {
        allowedTags: [],
        allowedAttributes: [],
        disallowedTagsMode: 'escapeRecursive',
      };
      if (!this.value) return '(none)';
      return urls2html(sanitize(this.value, opts), '_blank');
    },

    // displayAsCode determins when to display this as code.
    // Currently this just uses heuristics to look for XML but
    // this could use a form field property in the future to force
    // it on all inputs.
    displayAsCode() {
      if (!this.value) return false;
      if (this.value.indexOf('<?xml') !== -1) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~assets/css/colors';

  .response {
    white-space: pre-wrap;

    &.empty-value {
      font-weight: normal;
      color: $greycolor;
    }
  }

  textarea[disabled] {
    background-color: #f0f1f4;
    cursor: not-allowed;
    opacity: .5;
  }
</style>
